
// import React, { useState } from 'react';
// import { Box, Divider, Grid, IconButton, useMediaQuery } from '@mui/material';
// import BlogMiniCard from '../blog/BlogMiniCard';
// import { blogs } from './../data/BlogData';
// import BlogLargeCard from '../blog/BlogLargeCard';
// import { ReactComponent as NextIcon } from "./../../assets/NextIcon.svg"
// import { ReactComponent as PrevIcon } from "./../../assets/PrevIcon.svg"
// import { useTheme } from '@emotion/react';
// import { ReactComponent as ArrowButton } from "./../../assets/DisableArrow.svg"




// const MainComponentFinal = () => {




//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//     const [currentPage, setCurrentPage] = useState(1);

//     const ITEMS_PER_PAGE = isMobile ? 2 : isTablet ? 3 : 4;

//     const totalPages = Math.ceil((blogs.length - 1) / (ITEMS_PER_PAGE - 1));
//     const startIndex = (currentPage - 1) * (ITEMS_PER_PAGE - 1) + 1;
//     const endIndex = startIndex + (ITEMS_PER_PAGE - 1);
//     const currentCards = blogs.slice(startIndex, endIndex);

//     const handlePageChange = (direction) => {
//         if (direction === 'next' && currentPage < totalPages) {
//             setCurrentPage(currentPage + 1);
//         } else if (direction === 'prev' && currentPage > 1) {
//             setCurrentPage(currentPage - 1);
//         }
//     };

//     return (
//         <>

//             <Box mb={2} display="flex" justifyContent="left" marginX={0}>
//                 <BlogLargeCard
//                     key={blogs[0].id}
//                     id={blogs[0].id}
//                     image={`/blogImages/${blogs[0].id}.png`}
//                     title={blogs[0].title}
//                     blogDate={blogs[0].blogDate}
//                     content={blogs[0].content}
//                     imageStyle={{ width: '734px', height: '358px' }} // Custom image style
//                 />
//             </Box>
//             <Divider />
//             {(isMobile || isTablet) && (
//                 <Box display="flex" justifyContent="space-between" padding={2} >
//                     <IconButton onClick={() => handlePageChange('prev')} disabled={currentPage === 1}>
//                         <PrevIcon />
//                     </IconButton>
//                     <IconButton onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
//                         <NextIcon />
//                     </IconButton>
//                 </Box>
//             )}
//             <Box display="flex" alignItems="center" mt={isMobile ? 2 : 6} mb={isMobile ? 4 : 6}>
//                 {!(isMobile || isTablet) &&
//                     <IconButton onClick={() => handlePageChange('prev')} disabled={currentPage === 1}>
//                         <PrevIcon />
//                     </IconButton>}
//                 <Grid container spacing={4} wrap="nowrap">
//                     {currentCards.map((card) => (
//                         <Grid item key={card.id} xs={12} sm={12} md={4}>
//                             <BlogMiniCard
//                                 id={card.id}
//                                 image={`/blogImages/${card.id}.png`}
//                                 title={card.title}
//                                 blogDate={card.blogDate}
//                                 content={card.content}
//                             />
//                         </Grid>

//                     ))}

//                 </Grid>

//                 {!(isMobile || isTablet) && <IconButton onClick={() => handlePageChange('next')} disabled={currentPage === totalPages}>
//                     <NextIcon />
//                 </IconButton>}

//             </Box>


//         </>
//     );
// };

// export default MainComponentFinal;
import React, { useState } from 'react';
import { Box, Container, IconButton, useMediaQuery } from '@mui/material';
import BlogMiniCard from '../blog/BlogMiniCard';
import { getSortedBlogPosts } from '../../blogs/blogConfig';
import { AMITASOFT_BRAND } from '../../theme/amitasoftBrand';
import BlogLargeCard from '../blog/BlogLargeCard';
import { ReactComponent as NextIcon } from "./../../assets/NextIcon.svg";
import { ReactComponent as PrevIcon } from "./../../assets/PrevIcon.svg";
import { ReactComponent as DisabledPrevArrowButton } from "./../../assets/DisabledPrevIcon.svg"
import { ReactComponent as DisabledNextArrowButton } from "./../../assets/DisabledNextIcon.svg"
import { useTheme } from '@emotion/react';

const MainComponentFinal = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const [currentPage, setCurrentPage] = useState(1);
    const sortedBlogs = getSortedBlogPosts();
    const featuredBlog = sortedBlogs.find((post) => post.featured) || sortedBlogs[0];
    const carouselBlogs = sortedBlogs.filter((post) => post.slug !== featuredBlog.slug);

    const ITEMS_PER_PAGE = isMobile ? 2 : isTablet ? 3 : 4;

    const totalPages = Math.ceil(carouselBlogs.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const currentCards = carouselBlogs.slice(startIndex, endIndex);

    const handlePageChange = (direction) => {
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        } else if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <>
            <Box mb={2} display="flex" justifyContent="left" marginX={0}>
                <BlogLargeCard
                    key={featuredBlog.slug}
                    slug={featuredBlog.slug}
                    image={featuredBlog.image}
                    imageAlt={featuredBlog.imageAlt}
                    title={featuredBlog.title}
                    blogDate={featuredBlog.publishedDate}
                    description={featuredBlog.description}
                    layout={featuredBlog.layout}
                />
            </Box>
            <Container maxWidth="lg">
                <Box
                    sx={{
                        width: '100%',
                        height: 0,
                        border: `1px solid ${AMITASOFT_BRAND.lightGray}`,
                        my: 2,
                    }}
                />
            </Container>
            {(isMobile || isTablet) && (
                <Box display="flex" justifyContent="space-between" padding={2}>
                    <IconButton
                        onClick={() => handlePageChange('prev')}
                        disabled={currentPage === 1}
                        sx={(theme) => ({
                            border: '2px solid rgba(34, 34, 34, 0.6)',
                            borderRadius: '50%',
                            width: theme.spacing(5),
                            height: theme.spacing(5),
                        })}
                    >
                        {currentPage === 1 ? <DisabledPrevArrowButton /> : <PrevIcon />}
                    </IconButton>
                    <IconButton
                        onClick={() => handlePageChange('next')}
                        disabled={currentPage === totalPages}
                        sx={(theme) => ({
                            border: currentPage === totalPages ? '2px solid rgba(34, 34, 34, 0.6)' : `1px solid ${AMITASOFT_BRAND.accentInteractive}`,
                            borderRadius: '50%',
                            width: theme.spacing(5),
                            height: theme.spacing(5),
                        })}
                    >
                        {currentPage === totalPages ? <DisabledNextArrowButton /> : <NextIcon />}
                    </IconButton>
                </Box>
            )}
            <Box
                sx={{
                    display: { xs: 'block', md: 'flex' },
                    alignItems: 'center',
                    gap: { md: 2 },
                    mt: isMobile ? 2 : 6,
                    mb: isMobile ? 4 : 6,
                    px: { md: 2 },
                }}
            >
                {!(isMobile || isTablet) && (
                    <IconButton
                        onClick={() => handlePageChange('prev')}
                        disabled={currentPage === 1}
                        sx={(theme) => ({
                            flexShrink: 0,
                            alignSelf: 'center',
                            bgcolor: AMITASOFT_BRAND.white,
                            border: '2px solid rgba(34, 34, 34, 0.6)',
                            borderRadius: '50%',
                            width: theme.spacing(5),
                            height: theme.spacing(5),
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        })}
                    >
                        {currentPage === 1 ? <DisabledPrevArrowButton /> : <PrevIcon />}
                    </IconButton>
                )}
                <Box
                    sx={{
                        flex: { md: 1 },
                        minWidth: 0,
                        width: '100%',
                        display: 'grid',
                        gridTemplateColumns: `repeat(${ITEMS_PER_PAGE}, minmax(0, 1fr))`,
                        gap: { xs: 2, md: 1.5 },
                        alignItems: 'stretch',
                    }}
                >
                    {currentCards.map((card) => (
                        <BlogMiniCard
                            key={card.slug}
                            slug={card.slug}
                            image={card.image}
                            imageAlt={card.imageAlt}
                            title={card.title}
                            blogDate={card.publishedDate}
                            description={card.description}
                        />
                    ))}
                </Box>
                {!(isMobile || isTablet) && (
                    <IconButton
                        onClick={() => handlePageChange('next')}
                        disabled={currentPage === totalPages}
                        sx={(theme) => ({
                            flexShrink: 0,
                            alignSelf: 'center',
                            bgcolor: AMITASOFT_BRAND.white,
                            border: currentPage === totalPages ? '2px solid rgba(34, 34, 34, 0.6)' : `1px solid ${AMITASOFT_BRAND.accentInteractive}`,
                            borderRadius: '50%',
                            width: theme.spacing(5),
                            height: theme.spacing(5),
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        })}
                    >
                        {currentPage === totalPages ? <DisabledNextArrowButton /> : <NextIcon />}
                    </IconButton>
                )}
            </Box>
        </>
    );
};

export default MainComponentFinal;
